/** Shared wording + formatting for the undeliverable-addresses surface.
 *
 * One map, used by the list and the detail page, so the two cannot
 * disagree about what a reason is called (the FAILURE_REASON_PROSE
 * precedent). The fallback is the raw code: a grown server vocabulary
 * must surface rather than vanish.
 */

const REASON_PROSE: Record<string, string> = {
  hard_bounce: 'Hard bounce',
  spam: 'Marked as spam',
  unsub: 'Unsubscribed via the mail provider',
  soft_bounce_repeated: 'Repeated soft bounces',
  manual: 'Manually suppressed',
}

export function reasonProse(reason: string): string {
  return REASON_PROSE[reason] ?? reason
}

/** Suppression and event timestamps are instants (webhook arrival
 * times), rendered in the operator's zone — unlike business dates,
 * which are JST calendar days and use `formatBusinessDate`. */
export function formatWhen(value: string | null): string {
  if (value === null) return '—'
  return new Intl.DateTimeFormat('en', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value))
}

/** A digest is unreadable; eight hex chars is enough to tell rows
 * apart while saying "this is a fingerprint, not an address". */
export function shortHash(emailHash: string): string {
  return `${emailHash.slice(0, 8)}…`
}
